/**
 * useLabelActions — Iter 156.3 (Feb 27, 2026, Yash).
 *
 * Extracted from ChatsPage.jsx. The three label-management handlers
 * (add / remove / toggle) all hit the same `updateLabels` API and
 * follow the same optimistic-update pattern.
 */
import { leadActionsApi } from "../lib/api";
import { toast } from "sonner";

export const useLabelActions = ({
  selectedLead,
  setSelectedLead,
  setChats,
  setNewLabelText,
  setShowLabelInput,
  fetchLabels,
}) => {
  const updateOptimistic = async (newLabels, errorMsg) => {
    try {
      await leadActionsApi.updateLabels(selectedLead.id, newLabels);
      setSelectedLead(prev => prev ? { ...prev, labels: newLabels } : prev);
      setChats(prev => prev.map(c => c.id === selectedLead.id ? { ...c, labels: newLabels } : c));
      fetchLabels();
      return true;
    } catch (e) {
      toast.error(errorMsg);
      return false;
    }
  };

  const handleAddLabel = async (labelText) => {
    if (!selectedLead || !labelText.trim()) return;
    const currentLabels = selectedLead.labels || [];
    if (currentLabels.includes(labelText.trim())) return;
    const newLabels = [...currentLabels, labelText.trim()];
    const ok = await updateOptimistic(newLabels, "Failed to add label");
    if (ok) { setNewLabelText(""); setShowLabelInput(false); }
  };

  const handleRemoveLabel = async (labelText) => {
    if (!selectedLead) return;
    const newLabels = (selectedLead.labels || []).filter(l => l !== labelText);
    await updateOptimistic(newLabels, "Failed to remove label");
  };

  const handleToggleLabel = async (labelText) => {
    if (!selectedLead) return;
    const currentLabels = selectedLead.labels || [];
    const newLabels = currentLabels.includes(labelText)
      ? currentLabels.filter(l => l !== labelText)
      : [...currentLabels, labelText];
    await updateOptimistic(newLabels, "Failed to update label");
  };

  return { handleAddLabel, handleRemoveLabel, handleToggleLabel };
};
